// eslint-disable-next-line import/prefer-default-export
export enum ModalState {
    STEP1,
    STEP2,
    STEP3,
}
